import { PropsWithChildren } from 'react'

import { useGleapChat } from '@/hooks/use-gleap-chat'

const GLEAP_API_KEY = import.meta.env.VITE_GLEAP_API_KEY ?? ''

export function GleapProvider({ children }: PropsWithChildren) {
	useGleapChat({
		apiKey: GLEAP_API_KEY,
	})

	return <>{children}</>
}
